import { createAction } from '../../../store.model';
import { FilterOptions } from '../model/filter-options.model';
import { ActionType } from '../transcript-dialog.action';

export interface FilterQuotes {
    opts: FilterOptions;
}

export const filterQuotes = createAction<ActionType, FilterQuotes>(
    ActionType.COACHING_DETAIL__TD__FILTER_QUOTES,
);
